import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=cad515a0&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=cad515a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad515a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cad515a0')) {
      api.createRecord('cad515a0', component.options)
    } else {
      api.reload('cad515a0', component.options)
    }
    module.hot.accept("./infoForm.vue?vue&type=template&id=cad515a0&scoped=true", function () {
      api.rerender('cad515a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/components/infoForm.vue"
export default component.exports